import { bool, number, string } from "prop-types";
import React from "react";
import './styles.scss';

const TextArea = ({ noResize = false, rowNum = 6, text, disabled = false, defaultValue = "", maxLength = null, onChange, id }) => {
  return (
    <textarea
      id={id}
      className={`input-group rounded text-area ${noResize ? "fixed-size" : ""}`}
      placeholder={text}
      rows={rowNum}
      disabled={disabled}
      defaultValue={defaultValue}
      maxLength={maxLength}
      onChange={onChange}
    />
  );
};



TextArea.propTypes = {
  disabled: bool,
  noResize: bool,
  rowNum: number,
  text: string.isRequired,
  maxLength: number
};

export default TextArea;
